/**
 * Sat telefona naspram servera.
 *
 * Analiza 2.0 (D11), 14.10.2026: telefon vraćen na 2020. slao je dolaske iz
 * 2020. i niko to nije video. Server sad meri odstupanje po „sada" koje
 * telefon pošalje uz paket i ispravlja vremena; ovde se isto odstupanje
 * pokazuje vozaču, da podesi sat — ispravljeno vreme je dobro, tačno je bolje.
 */

/** Odstupanje do kog je sat „tačan", u minutima. Isto kao na serveru. */
export const TOLERANCIJA_MINUTA = 5;

/** Lokalno vreme bez zone, isti oblik kao `deviceNow()` i serverski `serverNow`. */
function parse(naivno: string): number {
  const m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?/.exec(naivno);
  if (!m) return Number.NaN;
  return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] ? +m[6] : 0).getTime();
}

/**
 * Za koliko minuta sat telefona odstupa od servera: pozitivno = telefon
 * kasni, negativno = žuri. NaN kad se ne može izračunati.
 */
export function odstupanjeMinuta(serverNow: string, deviceNow: string): number {
  const s = parse(serverNow);
  const d = parse(deviceNow);
  if (Number.isNaN(s) || Number.isNaN(d)) return Number.NaN;
  return Math.round((s - d) / 60000);
}

/** Rečenica za vozača, ili ništa kad je sat u redu. */
export function porukaOSatu(minuta: number): string | null {
  if (Number.isNaN(minuta) || Math.abs(minuta) <= TOLERANCIJA_MINUTA) return null;

  const apsolutno = Math.abs(minuta);
  const trajanje = apsolutno >= 60
    ? `${Math.floor(apsolutno / 60)} h ${apsolutno % 60} min`
    : `${apsolutno} min`;
  const smer = minuta > 0 ? 'kasni' : 'žuri';

  return `Sat telefona ${smer} ${trajanje}. Podesi ga (automatsko vreme) — `
    + 'vremena predaje se ispravljaju pri slanju, ali tačan sat je bolji.';
}
